import AMp4 from '../assets/video/a-video.mp4'
import APoster from '../assets/video/a-poster.webp'
import ASub from '../assets/video/a-video.vtt'
import AWebM from '../assets/video/a-video.webm'
import Abg from '../assets/video/a.webp'
import BMp4 from '../assets/video/b-video.mp4'
import BPoster from '../assets/video/b-poster.webp'
import BSub from '../assets/video/b-video.vtt'
import BWebM from '../assets/video/b-video.webm'
import Bbg from '../assets/video/b.webp'
import CMp4 from '../assets/video/c-video.mp4'
import CPoster from '../assets/video/c-poster.webp'
import CWebM from '../assets/video/c-video.webm'
import Cbg from '../assets/video/c.webp'
import DMp4 from '../assets/video/d-video.mp4'
import DPoster from '../assets/video/d-poster.webp'
import DWebM from '../assets/video/d-video.webm'
import Dbg from '../assets/video/d.webp'
import EMp4 from '../assets/video/e-video.mp4'
import EPoster from '../assets/video/e-poster.webp'
import EWebM from '../assets/video/e-video.webm'
import Ebg from '../assets/video/e.webp'
import FMp4 from '../assets/video/f-video.mp4'
import FPoster from '../assets/video/f-poster.webp'
import FWebM from '../assets/video/f-video.webm'
import Fbg from '../assets/video/f.webp'
import GMp4 from '../assets/video/g-video.mp4'
import GPoster from '../assets/video/g-poster.webp'
import GWebM from '../assets/video/g-video.webm'
import Gbg from '../assets/video/g.webp'
import HMp4 from '../assets/video/h-video.mp4'
import HPoster from '../assets/video/h-poster.webp'
import HWebM from '../assets/video/h-video.webm'
import Hbg from '../assets/video/h.webp'

export const AllVideoExercises = [
  {
    id: 1,
    letter: 'a',
    btnBg: Abg,
    videoData: {
      letter: 'a',
      title: 'The Cat And The Camel',
      description: 'Loosens up the lower spine.',
      videoMp4: AMp4,
      videoWebM: AWebM,
      poster: APoster,
      sub: ASub,
    }
  },
  {
    id: 2,
    letter: 'b',
    btnBg: Bbg,
    videoData: {
      letter: 'b',
      title: 'The Child Pose',
      description: 'Stretches out the spine, hips, thighs and ankles.',
      videoMp4: BMp4,
      videoWebM: BWebM,
      poster: BPoster,
      sub: BSub,
    }
  },
  {
    id: 3,
    letter: 'c',
    btnBg: Cbg,
    videoData: {
      letter: 'c',
      title: 'The Bridge',
      description: 'Increases core stability.',
      videoMp4: CMp4,
      videoWebM: CWebM,
      poster: CPoster,
      sub: null,
    }
  },
  {
    id: 4,
    letter: 'd',
    btnBg: Dbg,
    videoData: {
      letter: 'd',
      title: 'The Supine Piriformis Stretch',
      description: 'Relieves sciatica.',
      videoMp4: DMp4,
      videoWebM: DWebM,
      poster: DPoster,
      sub: null,
    }
  },
  {
    id: 5,
    letter: 'e',
    btnBg: Ebg,
    videoData: {
      letter: 'e',
      title: 'The Outer Hip Piriformis Stretch',
      description: 'Relieves sciatica.',
      videoMp4: EMp4,
      videoWebM: EWebM,
      poster: EPoster,
      sub: null,
    }
  },
  {
    id: 6,
    letter: 'f',
    btnBg: Fbg,
    videoData: {
      letter: 'f',
      title: 'The Long Adductor',
      description: 'Stretches out the inner thigh.',
      videoMp4: FMp4,
      videoWebM: FWebM,
      poster: FPoster,
      sub: null,
    }
  },
  {
    id: 7,
    letter: 'g',
    btnBg: Gbg,
    videoData: {
      letter: 'g',
      title: 'The Short Adductor Stretch',
      description: 'Stretches the top of the inner thigh.',
      videoMp4: GMp4,
      videoWebM: GWebM,
      poster: GPoster,
      sub: null,
    }
  },
  {
    id: 8,
    letter: 'h',
    btnBg: Hbg,
    videoData: {
      letter: 'h',
      title: 'The Pec Stretch',
      description: 'Lengthens the pecs and stops the shoulders from rolling forwards.',
      videoMp4: HMp4,
      videoWebM: HWebM,
      poster: HPoster,
      sub: null,
    }
  },
]